import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import NotFoundPage from './containers/NotFoundPage';
import NoQueryParams from './components/Error/NoQueryParams';
import ErrorPage from './components/Error';

// SUBSCRIPTION CONTAINERS
import MyPaymentMethods from './containers/MyPaymentMethods';
import PaymentMethodSelection from './containers/MethodSelectionPage/subscription';
import PaymentMethodPurchaseForm from './containers/PaymentMethods/subscription';
import MyAccount from './containers/MyAccount/myAccount';
import PurchaseAddOn from './containers/AddOnPlus';
import Invoice from './containers/Invoices/invoices';
import Receipt from './containers/Invoices/receipts';
import IdpSelectorAffiliates from './containers/IdpSelectorAffiliates';
import Devices from './containers/Devices';
import DefaultLayout from './containers/Layouts/DefaultLayoutContainer';
import MobileError from './components/Error/MobileError';

import { selectCountry, selectLanguage, selectContentProvider } from './global-selectors';

//import DirectvGOChangePlan from './containers/ChangePlan/directvgo';
import ChangeAddOn from './containers/ChangeAddOn/directvgo';
import ChangePlan from './containers/ChangePlan/default';

// #region components by client

// ACCEDO CONTAINERS
import AddOnsSelectionPageAccedo from './containers/ProductSelectionPage/accedo/addOns';
import PlanSelectionPageAccedo from './containers/ProductSelectionPage/accedo';
import ChangePlanAccedo from './containers/ChangePlan/accedo';

// MOTORPLAY CONTAINERS
import AddOnsSelectionPageMotorplay from './containers/ProductSelectionPage/motorplay/addOns';
import PlanSelectionPageMotorplay from './containers/ProductSelectionPage/motorplay';
import ChangePlanMotorplay from './containers/ChangePlan/motorplay';
import Products from './containers/ProductSelectionPage/motorplay/products';
import PaymentForm from './containers/ProductSelectionPage/motorplay/payment';

// #endregion components by client

const RouteWithDefaultLayout = ({
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => (
        <DefaultLayout>
          <Component {...props} />
        </DefaultLayout>
      )}
    />
  )
}

const Routes = ({ country, language, cp }) => {
  // Validate if language and country params are provided
  if (!country || !language || !cp) {
    return (
      <Switch>
        <Route path="/:client/error/:code" component={ErrorPage} />
        <Route exact path="*" component={NoQueryParams} />
      </Switch>
    );
  }

  return (
    <Switch>
      {/* CUSTOM SUBSCRIPTION ROUTES */}
      {/* DIRECTV GO */}
      {/* <Route exact path="/directvgo/subscribe/subscriptions" component={DirectvGOPlanSelection} />
      <Route exact path="/directvgo/subscribe/subscriptions/myaccount/change-plan" component={DirectvGOChangePlan} /> */}

      {/* ACCEDO */}
      <RouteWithDefaultLayout exact path="/accedo/subscribe/subscriptions" component={PlanSelectionPageAccedo} />
      <RouteWithDefaultLayout exact path="/accedo/subscribe/subscriptions/addOns" component={AddOnsSelectionPageAccedo} />
      <RouteWithDefaultLayout exact path="/accedo/subscribe/subscriptions/myaccount/change-plan" component={ChangePlanAccedo} />

      {/* MOTORPLAY */}
      <RouteWithDefaultLayout exact path="/motorplay/subscribe/subscriptions" component={PlanSelectionPageMotorplay} />
      <RouteWithDefaultLayout exact path="/motorplay/subscribe/subscriptions/addOns" component={AddOnsSelectionPageMotorplay} />
      <RouteWithDefaultLayout exact path="/motorplay/subscribe/subscriptions/myaccount/change-plan" component={ChangePlanMotorplay} />
      <RouteWithDefaultLayout exact path="/motorplay/subscribe/plans" component={Products} />
      <RouteWithDefaultLayout exact path="/motorplay/subscribe/payment" component={PaymentForm} />

      {/* GENERIC SUBSCRIPTION ROUTES */}
      {/* First Purchase Routes */}
      {/* <Route exact path="/:client/subscribe/subscriptions" component={ProductSelection} />
      <Route exact path="/:client/subscribe/subscriptions/addOns" component={AddOnSelection} /> */}

      {/* Purchase Routes */}
      <RouteWithDefaultLayout exact path="/:client/subscribe/subscriptions/myaccount/change-plan" component={ChangePlan} />
      <RouteWithDefaultLayout exact path="/:client/subscribe/subscriptions/myaccount/addon-plus" component={PurchaseAddOn} />
      <Route exact path="/:client/subscribe/subscriptions/myaccount/change-addon" component={ChangeAddOn} />

      {/* Payment Methods Selection Routes */}
      <RouteWithDefaultLayout exact path="/:client/subscribe/my-payment-methods" component={MyPaymentMethods} />
      <RouteWithDefaultLayout exact path="/:client/subscribe/methods" component={PaymentMethodSelection} />
      <RouteWithDefaultLayout exact path="/:client/subscribe/methods/:methodId/:subPaymentMethod" component={PaymentMethodPurchaseForm} />

      {/* Invoices/Receipt Single Routes */}
      <RouteWithDefaultLayout exact path="/:client/subscribe/subscriptions/invoices/:invoiceId" component={Invoice} />
      <RouteWithDefaultLayout exact path="/:client/subscribe/subscriptions/receipts/:invoiceId" component={Receipt} />

      {/* My Account Routes */}
      <RouteWithDefaultLayout
        exact path={[
          '/:client/subscribe/subscriptions/:tab(general|myaccount|payment-methods|new-payment-method|invoices)'
        ]} component={MyAccount}
      />
      <RouteWithDefaultLayout exact path='/:client/devices/limit' component={Devices} />

      {/* Operator Selector */}
      <RouteWithDefaultLayout exact path="/:client/binding/idp-selector" component={IdpSelectorAffiliates} />

      {/* Error Routes */}
      <Route path="/:client/mobile/feedback" component={MobileError} />
      <Route path="/:client/error/:code" component={ErrorPage} />
      <Route exact path="**" component={NotFoundPage} />
    </Switch>
  );
};

Routes.propTypes = {
  language: PropTypes.string,
  country: PropTypes.string,
  cp: PropTypes.string
};

const mapStateToProps = (state) => ({
  country: selectCountry(state),
  language: selectLanguage(state),
  cp: selectContentProvider(state)
});

export default connect(mapStateToProps)(Routes);
